import { makeStyles } from '@material-ui/core'


const TituloTheme = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
      },
      container: {
        display: "flex",
        alignItems: "center",
      },
      appBar: {
        alignItems: "center",
      }
}));

export default TituloTheme;